export default __webpack_public_path__ + "static/media/Preceptor.4888cfd7.png";